import type { IAnswer } from '../interfaces/answer.interface';

// Thread loading stays independent of AnswerHelper (which itself loads threads).
const listeners = new Set<(turn: IAnswer) => void>();
export const pendingWidgetRecovery = {
  subscribe(listener: (turn: IAnswer) => void) { listeners.add(listener); },
  notify(turn: IAnswer) { listeners.forEach((listener) => listener(turn)); },
};
